// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./Edit.module.css";
// CSS
// Services
// Services
// Models
import {
  I_City,
  I_Grade,
  I_UserData,
  I_UserInfo,
  I_UserStep3OTPData,
} from "../../../Models/interfaces";
// Models
// Utils
import SelectOptionBuilder from "../../../Utils/SelectOptionBuilder/SelectOptionBuilder";
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
import Spinner from "../../../Utils/Spinner/Spinner";
// Utils
// Services
import { getGrades_Service } from "../../../Services/Common/getGrades_Service";
import { getCities_Service } from "../../../Services/Common/getCities_Service";
import { getCurrentUserDataService } from "../../../Services/Profile/get/getCurrentUserDataService";
import { editProfileService } from "../../../Services/Profile/post/editProfileService";
import { sendUserImageService } from "../../../Services/Profile/post/sendUserImageService";
// Services
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Modules
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUserInfoService } from "../../../Services/Profile/get/getUserInfoService";
// Modules

const Edit = () => {
  // ************************************************** States
  const [userImg, setUserImg] = useState<File>();
  //
  const [grades, setGrades] = useState<I_Grade[]>([]);
  //
  const [cities, setCities] = useState<I_City[]>([]);
  //
  const [userData, setUserData] = useState<I_UserData>();
  //
  const [newUserData, setNewUserData] = useState<
    I_UserStep3OTPData & {
      cityName: string;
      gradeName: string;
    }
  >({
    name: "در حال بارگذاری",
    gradeId: 1,
    cityId: 1,
    cityName: "شهر را انتخاب کنید",
    gradeName: "مقطع را انتخاب کنید",
  });
  const [userInfo, setUserInfo] = useState<I_UserInfo>();
  const [isPending, setIsPending] = useState<boolean>();
  // ************************************************** States
  /********************************************************** */
  /********************************************************** */
  // ************************************************** Constants
  const navigate = useNavigate();
  const userToken = useContext(UserTokenContext);
  // console.log(userData);
  // ************************************************** Constants
  /********************************************************** */
  /********************************************************** */
  // ************************************************** Life Cycles
  useEffect(() => {
    getUserInfoService(userToken).then(({ data: { data } }) => {
      // console.log(data);
      setUserData(data);
      setNewUserData((prevState) => ({
        ...prevState,
        name: String(data.fullName),
        gradeId: data.grade_id,
        cityId: data.city_id,
        cityName: data?.city?.name || "لطفا شهر را انتخاب کنید",
        gradeName: data?.grade?.title || "لطفا مقطع را انتخاب کنید",
      }));
    });
  }, [userToken]);
  //
  useEffect(() => {
    getGrades_Service()
      .then(({ data: { data } }) => {
        setGrades(data);
      })
      .catch((err) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
    getCities_Service()
      .then(({ data: { data } }) => {
        setCities(data);
      })
      .catch((err) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
    getCurrentUserDataService(userToken)
      .then(({ data: { data } }) => {
        setUserInfo(data);
      })
      .catch((err) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken]);
  //
  useEffect(() => {
    sendUserImageService(userToken, userImg)
      .then(({ data: { error } }) => {
        console.log(error);
      })
      .catch((err) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userImg, userToken]);
  console.log(userData);
  // ************************************************** Life Cycles
  return (
    <>
      <div
        className={`${styles.step3Container} w-full h-full top-0 ${
          window.innerWidth > 600 ? "left-auto" : "left-0"
        } absolute bg-white flex items-center justify-center`}
      >
        {/* Waves */}
        <div
          className={`${styles.wave} ${styles.topWave} absolute top-0 left-0`}
        ></div>
        <div
          className={`${styles.wave} ${styles.bottomWave} absolute bottom-0 left-0`}
        ></div>
        {/* Waves */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}

        <div className={`${styles.innerContent} w-full px-4`}>
          <HelperHeader absoluteText="ویرایـــش مشخصـــــات" isBgWhite={true} />
          <div
            className={`${styles.imageContainer} flex items-center justify-center mt-4 rounded-full`}
          >
            <img
              src={
                userImg !== undefined
                  ? URL.createObjectURL(userImg)
                  : `https://easyno.ir//users/images/${userInfo?.profile_pic}`
              }
              alt=""
              className="w-20 h-20 rounded-full p-0.5"
              onClick={() => {
                const imgInput = document.getElementById("imgInput");
                if (!imgInput) return;
                console.log(imgInput);
                imgInput.click();
              }}
            />
            <input
              type="file"
              className="hidden"
              id="imgInput"
              multiple={false}
              onChange={(e: React.FormEvent<HTMLInputElement>) => {
                if (!e.currentTarget.files) return;
                setUserImg(e.currentTarget.files[0]);
              }}
            />
          </div>
          <p className="text-center my-2">
            {userInfo?.phone ?? "لطفا صبور باشید"}
          </p>
          <input
            type="text"
            className="w-full rounded-lg py-1.5 "
            placeholder={"نام و نام خانوادگی"}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (!e.currentTarget.value) {
                setNewUserData((prevState) => ({
                  ...prevState,
                  name: "",
                }));
                return;
              }
              setNewUserData((prevState) => ({
                ...prevState,
                name: e.target.value,
              }));
            }}
            value={newUserData.name}
          />
          <SelectOptionBuilder
            dataForBuildOptions={grades}
            initialShowName={newUserData.gradeName}
            onClick={(gradeId) => {
              console.log(gradeId);
              setNewUserData((prevState) => ({
                ...prevState,
                gradeId,
                gradeName: String(
                  grades.find((item) => Number(item.id) === Number(gradeId))
                    ?.title
                ),
              }));
            }}
            style={{
              marginLeft: window.innerWidth > 600 ? "-20px" : "",
            }}
          />
          <SelectOptionBuilder
            dataForBuildOptions={cities.map((item) => ({
              title: item.name,
              id: item.id,
            }))}
            initialShowName={newUserData.cityName}
            onClick={(cityId) => {
              console.log(cityId);
              setNewUserData((prevState) => ({
                ...prevState,
                cityId,
                cityName: String(
                  cities.find((item) => Number(item.id) === Number(cityId))
                    ?.name
                ),
              }));
            }}
            style={{
              marginLeft: window.innerWidth > 600 ? "-20px" : "",
            }}
          />
          <div className={`${styles.citiesOptionsContainer}`}></div>
          <button
            className={`${styles.submitBtn} text-white w-full text-center mt-4 rounded-lg py-2 flex items-center justify-center`}
            onClick={() => {
              const { cityId, gradeId, name } = newUserData;
              if (
                cityId !== "" &&
                gradeId !== "" &&
                //////////////////////////////////////////
                //////////////////////////////////////////
                //////////////////////////////////////////
                //////////////////////////////////////////
                //////////////////////////////////////////
                name !== ""
                //////////////////////////////////////////
                //////////////////////////////////////////
                //////////////////////////////////////////
                //////////////////////////////////////////
                //////////////////////////////////////////
              ) {
                setIsPending(true);

                editProfileService(
                  userToken,
                  String(name),
                  String(cityId),
                  String(gradeId)
                )
                  .then(({ data, status }) => {
                    setIsPending(false);
                    if (status === 200 || 201) {
                      console.log(data);
                      navigate("/");
                    } else {
                      toast("دوباره تلش کنید");
                    }
                  })
                  .catch((err: any) => {
                    console.log(err);
                    toast("دوباره تلاش کنید");
                    setIsPending(false);
                  });
              } else {
                toast("همه ی فیلد ها را پر کنید");
              }
            }}
          >
            {isPending ? (
              <>
                <Spinner />
              </>
            ) : (
              <>تایید و ذخیره</>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default Edit;
